var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 8.92497L1.4 15.425C1.06667 15.5583 0.75 15.5291 0.45 15.3375C0.15 15.1458 0 14.8666 0 14.5V1.49997C0 1.1333 0.15 0.854138 0.45 0.662471C0.75 0.470805 1.06667 0.441638 1.4 0.574971L16.8 7.07497C17.2167 7.2583 17.425 7.56664 17.425 7.99997C17.425 8.4333 17.2167 8.74164 16.8 8.92497ZM2 13L13.85 7.99997L2 2.99997V6.49997L8 7.99997L2 9.49997V13Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledSend);
export default __webpack_public_path__ + "static/media/disabled_send.760c8ce19488e6b36fe0e2d33e01d2db.svg";
export { ForwardRef as ReactComponent };